import { api } from "../.."

// função para pesquisar as ordens
const FinancialOrdersService = async (number: string, date: string, name: string, costCenter: string, status: string, page: number) => {

    const response = await api.get('financial/orders', {
        params: {
            number, date, name, costCenter, status, page
        }
    });

    return response;
    
}
// função para pesquisar as ordens

// função para pesquisar informações de uma ordem
const FinancialOrdersShowService = async (id: number) => {

    const response = await api.get(`financial/orders/${id}`);

    return response

}
// função para pesquisar informações de uma ordem

// função para pagar uma ordem
const FinancialOrderPayService = async (id: number, optionMoney: string) => {

    const response = await api.put(`financial/orders/pay/${id}`, {
        optionMoney
    });

    return response;

}
// função para pagar uma ordem

// função para pesquisar centros de custos
const FinancialOrdersCostCenterService = async () => {

    const response = await api.get(`financial/cost_centers`);

    return response;

}
// função para pesquisar centros de custos

export {
    FinancialOrdersService,
    FinancialOrdersShowService,
    FinancialOrderPayService,
    FinancialOrdersCostCenterService
}